/**
 * A short-lived flag any code-driven scroll (position restore, jump-to-tray,
 * scroll-to-top after "Update picks") sets right before it moves the
 * viewport, so `useV4CaptureTrigger`'s scroll listener can tell it apart from
 * a finger drag — native `scroll` events are identical either way (THE-962).
 *
 * Time-windowed rather than a plain boolean: a multi-frame restore loop
 * (`useScrollRestoration`) calls `markProgrammaticScroll()` on every frame,
 * which keeps re-extending the window for as long as it runs; a one-shot
 * `smooth` scroll (the saved-tray jump) has no completion callback, so its
 * caller passes a duration that covers the animation up front instead.
 */

let suppressUntil = 0;

export function markProgrammaticScroll(durationMs = 250): void {
  suppressUntil = Date.now() + durationMs;
}

export function isProgrammaticScroll(): boolean {
  return Date.now() < suppressUntil;
}
